<template>
  <AuthVisualShell
    :character-src="characterSrc"
    character-alt="Personagem Zinnes"
    character-class="character-image--register"
    gradient="linear-gradient(to bottom, rgba(5, 5, 5, 0.774), #7a12aac2)"
  >
    <div class="login-content">
      <h2>REALIZAR CADASTRO</h2>
      <p class="display-none">Junte-se à nossa comunidade criativa! Publique suas histórias ou descubra novos quadrinhos, HQs, novels e mangás feitos por autores independentes.</p>
      <v-form @submit.prevent="registerUserHandler" ref="form">
        <v-text-field
          label="Nome"
          v-model="name"
          :rules="nameRules"
          required
          :error-messages="erros.name"
        ></v-text-field>
        <v-text-field
          label="Nickname"
          v-model="nickname"
          :rules="nicknameRules"
          required
          :error-messages="erros.nickname"
        ></v-text-field>
        <v-text-field
          label="Email"
          v-model="email"
          :rules="emailRules"
          required
          :error-messages="erros.email"
        ></v-text-field>
        <v-text-field
          label="Senha"
          :type="showPassword ? 'text' : 'password'"
          v-model="password"
          :rules="passwordRules"
          required
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="togglePasswordVisibility('password')"
          append-icon-class="password-icon"
          :error-messages="erros.password"
        ></v-text-field>
        <v-text-field
          label="Confirmar Senha"
          :type="showPasswordConfirmation ? 'text' : 'password'"
          v-model="password_confirmation"
          :rules="passwordConfirmationRules"
          required
          :append-icon="showPasswordConfirmation ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="togglePasswordVisibility('confirmation')"
          append-icon-class="password-icon"
          :error-messages="erros.password_confirmation"
        ></v-text-field>
        <p class="login">
          Já tem conta?
          <router-link to="/login" style="text-decoration: none;">Efetuar login</router-link>
        </p>
        <v-btn
          :loading="isLoading"
          :disabled="isLoading"
          color="orange"
          class="btn-login"
          type="submit"
        >
          <template v-if="!isLoading">CADASTRAR</template>
          <template v-else>Carregando...</template>
        </v-btn>
        <div v-if="error" class="error">{{ error }}</div>
        <div v-if="success" class="success">{{ success }}</div>
      </v-form>
    </div>
  </AuthVisualShell>
</template>

<script>
import AuthVisualShell from '@/components/AuthVisualShell.vue';
import { registerUser } from '../server/userServe';
import {
  nameRules,
  nicknameRules,
  emailRules,
  passwordRules,
  passwordConfirmationRules
} from '@/utils/validationUtils';

export default {
  name: 'RegisterPage',
  components: {
    AuthVisualShell,
  },
  data() {
    return {
      name: '',
      nickname: '',
      email: '',
      password: '',
      password_confirmation: '',
      showPassword: false,
      showPasswordConfirmation: false,
      error: null,
      success: null,
      isLoading: false,
      nameRules,
      nicknameRules,
      emailRules,
      passwordRules,
      erros: {},
      characterSrc: require('@/assets/images/PersonZ.png'),
    };
  },
  computed: {
    passwordConfirmationRules() {
      return passwordConfirmationRules(this.password);
    },
  },
  methods: {
    async registerUserHandler() {
      this.erros = {};
      const isValid = this.$refs.form.validate();

      if (!isValid) {
        this.error = 'Por favor, corrija os erros no formulário.';
        return;
      }

      this.isLoading = true;

      const dataUser = {
        name: this.name,
        nickname: this.nickname.toLowerCase(),
        email: this.email.toLowerCase(),
        password: this.password,
        password_confirmation: this.password_confirmation,
      };

      try {
        this.success = await registerUser(dataUser);
        this.$refs.form.reset();
        this.success = 'Cadastro realizado com sucesso!';
        this.$router.push('/login');
        this.error = null;
      } catch (error) {
        this.error = error.message || 'Erro ao registrar usuário';
        this.success = null;
        this.erros = error.errors;
        console.error('Erro ao registrar usuário:', this.error);
      } finally {
        this.isLoading = false;
      }
    },
    togglePasswordVisibility(type) {
      if (type === 'password') {
        this.showPassword = !this.showPassword;
      } else if (type === 'confirmation') {
        this.showPasswordConfirmation = !this.showPasswordConfirmation;
      }
    },
  },
};
</script>

<style scoped>
.password-icon {
  margin-left: -100px !important;
  z-index: 10;
}

.login {
  text-align: start;
}

.error {
  color: red;
}

.success {
  color: green;
}
@media (max-width: 540px) {
  .display-none {
    display: none;
  }
}
</style>
